import type { BlockedIndicator } from '@gallop/domain'
import { cx } from '@/utils/cx'
import { StatusPill } from './status-pill'

/** One status slot: Stalled wins; its age stays available as text in the accessible name and hover hint. */
export function WorkItemStatus({ status, blocked, assigneeKind = null, fixed = false }: { status: string, blocked?: BlockedIndicator | null, assigneeKind?: 'person' | 'agent' | null, fixed?: boolean }) {
  if (status !== 'blocked' || !blocked)
    return <StatusPill status={status} assigneeKind={assigneeKind} fixed={fixed} />
  const label = blocked.stalled ? `Stalled · Blocked ${blocked.days}d` : blocked.label
  const style = blocked.severity === 'stalled'
    ? { background: 'var(--color-bg-error-secondary)', color: 'var(--color-text-error-primary)' }
    : blocked.severity === 'aging'
      ? { background: 'var(--color-bg-warning-secondary)', color: 'var(--color-text-warning-primary)' }
      : { background: 'var(--shell-quiet-bg)', color: 'var(--shell-quiet-fg)' }
  return (
    <span
      className={cx('inline-flex shrink-0 items-center justify-center rounded-full px-2 py-0.5 text-xs whitespace-nowrap', fixed && 'w-28')}
      style={style}
      title={`${label}. Blocked since ${blocked.since}.`}
      aria-label={label}
      data-testid="blocked-age-chip"
      data-severity={blocked.severity}
      data-days={blocked.days}
    >
      {blocked.label}
    </span>
  )
}
